import React from 'react'
import { 
    Checkbox, 
    Checklist,
    Color, 
    Column, 
    Date,
    DatetimeLocal,
    Divider, 
    File,
    FormGroup, 
    FormGroupCheckbox, 
    FormGroupChecklist, 
    FormGroupColor, 
    FormGroupDate,
    FormGroupDatetimeLocal,
    FormGroupFile,
    FormGroupLink,
    FormGroupMonth,
    FormGroupMultiple,
    FormGroupNumber,
    FormGroupPassword,
    FormGroupRadio,
    FormGroupRange,
    FormGroupSelect,
    FormGroupSignature,
    FormGroupText, 
    FormGroupTextarea,
    FormGroupTime, 
    FormGroupUrl, 
    FormGroupWeek,
    HelpText,    
    Label,
    Link,
    Month,
    Multiple,
    Number,
    Password,
    PageHeader,
    Paragraph,
    Radio, 
    Range, 
    Repeater, 
    Row, 
    Section, 
    Select,
    Signature,
    Spacer,
    StaticText,
    Text,
    Textarea,
    Time,
    Url,
    Week } from './'
import evaluate from 'simple-evaluate';

export const Element = (props) => {     
    const customProps = { ...props, render: true };
    const { element } = customProps;

    if (element) {
        if (element.name) {        
            customProps.modelPath = (customProps.modelPath == null || customProps.modelPath.length === 0 ? "" : `${customProps.modelPath}.`) + element.name;
        }

        if (element.renderIf) {
            const { context } = customProps;
            const $item = customProps.modelPath ? context.readModel(customProps.modelPath, {}) : undefined;
            const $root = context.getModel();
            customProps.render = evaluate({ $root: $root, $item: $item }, element.renderIf);
        }
    }

    if (customProps.render === false)
        return null;

    return (
        <>            
            {{
                "Checkbox": <Checkbox {...customProps}></Checkbox>,
                "Checklist": <Checklist {...customProps}></Checklist>,
                "Color": <Color {...customProps}></Color>,
                "Column": <Column {...customProps}></Column>,
                "Date": <Date {...customProps}></Date>,
                "DatetimeLocal": <DatetimeLocal {...customProps}></DatetimeLocal>,
                "Divider": <Divider {...customProps}></Divider>,
                "File": <File {...customProps}></File>,
                "FormGroup": <FormGroup {...customProps}></FormGroup>,
                "FormGroupChecklist": <FormGroupChecklist {...customProps}></FormGroupChecklist>,
                "FormGroupCheckbox": <FormGroupCheckbox {...customProps}></FormGroupCheckbox>,
                "FormGroupColor": <FormGroupColor {...customProps}></FormGroupColor>,
                "FormGroupDate": <FormGroupDate {...customProps}></FormGroupDate>,
                "FormGroupDatetimeLocal": <FormGroupDatetimeLocal {...customProps}></FormGroupDatetimeLocal>,
                "FormGroupFile": <FormGroupFile {...customProps}></FormGroupFile>,
                "FormGroupLink": <FormGroupLink {...customProps}></FormGroupLink>,
                "FormGroupMonth": <FormGroupMonth {...customProps}></FormGroupMonth>,
                "FormGroupMultiple": <FormGroupMultiple {...customProps}></FormGroupMultiple>,
                "FormGroupNumber": <FormGroupNumber {...customProps}></FormGroupNumber>,
                "FormGroupPassword": <FormGroupPassword {...customProps}></FormGroupPassword>,
                "FormGroupRadio": <FormGroupRadio {...customProps}></FormGroupRadio>,
                "FormGroupRange": <FormGroupRange {...customProps}></FormGroupRange>,
                "FormGroupSelect": <FormGroupSelect {...customProps}></FormGroupSelect>,
                "FormGroupSignature": <FormGroupSignature {...customProps}></FormGroupSignature>,
                "FormGroupText": <FormGroupText {...customProps}></FormGroupText>,
                "FormGroupTextarea": <FormGroupTextarea {...customProps}></FormGroupTextarea>,
                "FormGroupTime": <FormGroupTime {...customProps}></FormGroupTime>,
                "FormGroupUrl": <FormGroupUrl {...customProps}></FormGroupUrl>,
                "FormGroupWeek": <FormGroupWeek {...customProps}></FormGroupWeek>,
                "HelpText": <HelpText {...customProps}></HelpText>,                                
                "Label": <Label {...customProps}></Label>,
                "Link": <Link {...customProps}></Link>,
                "Month": <Month {...customProps}></Month>,
                "Multiple": <Multiple {...customProps}></Multiple>,
                "Number": <Number {...customProps}></Number>,
                "Password": <Password {...customProps}></Password>,
                "PageHeader": <PageHeader {...customProps}></PageHeader>,
                "Paragraph": <Paragraph {...customProps}></Paragraph>,
                "Radio": <Radio {...customProps}></Radio>,
                "Range": <Range {...customProps}></Range>,
                "Repeater": <Repeater {...customProps}></Repeater>,
                "Row": <Row {...customProps}></Row>,
                "Section": <Section {...customProps}></Section>,
                "Select": <Select {...customProps}></Select>,
                "Signature": <Signature {...customProps}></Signature>,
                "Spacer": <Spacer {...customProps}></Spacer>,
                "StaticText": <StaticText {...customProps}></StaticText>,
                "Text": <Text {...customProps}></Text>,
                "Textarea": <Textarea {...customProps}></Textarea>,
                "Time": <Time {...customProps}></Time>,
                "Url": <Url {...customProps}></Url>,
                "Week": <Week {...customProps}></Week>
            }[props.element.type]} 
        </>        
    )
}

export default Element;
